var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 81,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.368%",
    y1: "204.871%",
    x2: "50%",
    y2: "-95.175%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52DDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "168.934%",
    x2: "0%",
    y2: "-40.361%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51D0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504EFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409 -1473)",
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeWidth: 1.134,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.71 1495.56h19.369v-18.497H445.71v18.497zm-1.513 3.063h9.836v16.074h3.026v-16.074h9.533c.835 0 1.513-.686 1.513-1.531v-21.56c0-.846-.678-1.532-1.513-1.532h-22.395c-.836 0-1.513.686-1.513 1.532v21.56c0 .845.677 1.531 1.513 1.531zM445.71 1549.977h19.369v-18.253H445.71v18.253zm20.882-21.275h-9.684v-5.626h-3.026v5.626h-9.685c-.836 0-1.513.677-1.513 1.51v21.277c0 .834.677 1.511 1.513 1.511h22.395c.835 0 1.513-.677 1.513-1.511v-21.276c0-.834-.678-1.511-1.513-1.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23 1549.998h19.693v-18.127h-19.692v18.127zm-66.153 0h19.692v-18.127h-19.692v18.127zm87.385-21.128h-9.847v-9.081c0-.829-.689-1.501-1.538-1.501h-66.77c-.85 0-1.538.672-1.538 1.5v9.082h-9.23c-.851 0-1.539.672-1.539 1.5v21.13c0 .828.688 1.5 1.538 1.5h22.77c.849 0 1.538-.672 1.538-1.5v-21.13c0-.828-.69-1.5-1.538-1.5h-10.462v-7.58h63.692v7.58h-9.846c-.85 0-1.538.672-1.538 1.5v21.13c0 .828.688 1.5 1.538 1.5h22.77c.849 0 1.538-.672 1.538-1.5v-21.13c0-.828-.69-1.5-1.538-1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.921cc9587fc44c1805f3e578f981e911.svg";
export { ForwardRef as ReactComponent };